import React from "react";
import { HiOutlineDownload, HiOutlineInformationCircle } from "react-icons/hi";

// The backend reads these uploads row by row as CSV; any other file type is ignored and
// nothing is saved. Column headers must match exactly (they are case-sensitive).
const CsvFormatHint = ({ columns, templateName }) => {
  const downloadTemplate = () => {
    const blob = new Blob([`${columns.join(",")}\n`], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = templateName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="flex flex-col gap-3 p-4 my-3 text-sm border rounded-lg sm:flex-row sm:items-start sm:justify-between border-sky-200 bg-sky-50 text-sky-900">
      <div className="flex gap-2">
        <HiOutlineInformationCircle className="w-5 h-5 shrink-0" />
        <div>
          <p className="font-medium">Upload a .csv file with these column headers, spelled exactly as shown:</p>
          <p className="mt-1 font-mono text-xs break-words">{columns.join(", ")}</p>
          <p className="mt-1 text-xs text-sky-800">
            Excel files: use File → Save As → CSV.
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={downloadTemplate}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border rounded-md shrink-0 border-sky-300 hover:bg-sky-100"
      >
        <HiOutlineDownload className="w-4 h-4" />
        Download CSV template
      </button>
    </div>
  );
};

export const STUMPAGE_COLUMNS = [
  "StockNumber",
  "ContTreeNumber",
  "Barcode",
  "SpeciesName",
  "SpeciesCode",
  "DiameterDB",
  "DiameterDT",
  "Length",
  "BoleVolume",
  "BranchVolume",
  "Volume",
];

export const YIELD_COLUMNS = ["SPECIE", "COUNT", "AVERAGEM3", "AVERAGEVOLUME", "VOLUMRBYCOUNT"];

export default CsvFormatHint;
